import React, { useEffect, useState } from 'react';

import { MultiSelect } from 'primereact/multiselect';
import { IProductTemplateAttribute } from 'components/dashboard/product-template-table/utils/interfaces';
import { T } from "services/lang/LanguageService";

type UserSignatureTypeProps = {
  attribute: IProductTemplateAttribute;
  attributes: IProductTemplateAttribute[];
  onRequiredFieldChange: (reqFields: string[]) => void;
}

const UserSignatureType: React.FC<UserSignatureTypeProps> = ({
  attribute,
  attributes,
  onRequiredFieldChange,
}) => {
  const [selectedAttributes, setSelectedAttributes] = useState<string[]>(
    attribute?.validationOptions?.requiredAttributes ?? []
  );

  useEffect(() => {
    onRequiredFieldChange(selectedAttributes);
  }, [selectedAttributes]);

  return (
    <div className="p-field p-col-6">
      <label>{T("word.required-fields")}</label>
      <MultiSelect
        placeholder="Select required fields"
        value={selectedAttributes}
        options={attributes.map(attr => attr.referenceName)}
        onChange={e => setSelectedAttributes(e.value)}
        className="p-inputtext-sm"
      />
    </div>
  );
};

export default UserSignatureType